import React, { useRef } from 'react';

import useTranslate from '../../../../common/hooks/useTranslate';
import useClickOutside from '../../../../common/hooks/useClickOutside';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../../../../redux/store';
import { DOCUSIGN, MODAL } from '../../../../redux/types';

import { IDocuSignData } from '../../types/IDocuSignData';
import { IDocuSignDropdown } from '../../types/IDocuSignDropdown';

import './docuSignDropdown.scss';

const DocuSignDropdown: React.FC<IDocuSignDropdown> = ({ id, signData }) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);

  const impersonate = useSelector((state: RootState) => state.impersonate.impersonate);

  const goToDocuSign = (item: IDocuSignData): void => {
    if (impersonate) {
      dispatch({ type: MODAL.SWITCH_IMPERSONATE_MODE_MODAL });
    } else {
      dispatch({ type: MODAL.SWITCH_REDIRECTING_TO_DS_MODAL, payload: item });
    }
  };

  const clickOutsideHandler = (): void => {
    dispatch({ type: DOCUSIGN.CLOSE_DOCUSIGN_DROPDOWN });
  };

  useClickOutside(wrapperRef, clickOutsideHandler, id);

  return (
    <>
      {signData.length > 0 && (
        <div className='docusign-dropdown-wrapper' ref={wrapperRef}>
          {signData.map((item, key) => (
            <div className='docusign-dropdown-item' key={key}>
              <span>{item.name}</span>
              <span className='sign-btn pointer' onClick={() => goToDocuSign(item)}>
                {item.type !== 'signer' ? t('DOCUSIGN.VIEW_BUTTON') : item.isSigned === true ? t('DOCUSIGN.SIGNED_BUTTON') : t('DOCUSIGN.SIGN_BUTTON')}
              </span>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default DocuSignDropdown;
